// extracted by css-extract-rspack-plugin
export default {"mapTypeButtonGroup":"toggleTab-module__mapTypeButtonGroup","mapTypeButton":"toggleTab-module__mapTypeButton","mapTypeButtonActive":"toggleTab-module__mapTypeButtonActive"};